import {
  AfterViewInit,
  ChangeDetectionStrategy, 
  Component, 
  Input,
  Output,
  OnChanges, 
  ViewEncapsulation,
  EventEmitter
} from '@angular/core';
import { ICardSelf } from '@knz/util';
 

@Component({
  selector: 'card-self',
  exportAs: 'cardSelf',
  templateUrl: './card-self.component.html',
  host: { '[class.card-self]': 'true' },
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CardSelfComponent implements AfterViewInit, OnChanges {
  @Input() number: number = 1;
  @Input() type: string = "";
  @Input() data: ICardSelf = {};
  @Output() itemClickEvent = new EventEmitter<any>();

  get rowNumber() {
    if (this.number >= 10) {
      return this.number;
    } else if (this.number >= 1 && this.number < 10) {
      return "0" + this.number;
    } else {
      return "01";
    }
  }

  constructor() {}
 

  ngAfterViewInit() { 
  }

  ngOnChanges() { 
  }

  
  cardClick() {
    console.log(this.data)
    this.itemClickEvent.emit(this.data);
  }
}
